import SalesCategory from '../../components/SalesOverviewComponents/SalesCategory/SalesCategory';
import * as S from './SalesOverviewPage.style';
import DateSelector from '../../components/SalesOverviewComponents/DateSelector/DateSelector';
import {useState} from 'react';
import {ArrowRightOutlined} from '@ant-design/icons';
import RouterButton from '../../common/RouterButton/RouterButton';
import SalesOverview from '../../components/SalesOverviewComponents/SalesOverview/SalesOverview';
import CommonContainer from '../../common/Container/CommonContainer';
import {SILOVE_ANALYTICS_URL, SINOR_ANALYTICS_URL} from '../../constant/external.url';

export default function SalesOverviewPage() {
    const [currentCategory, setCurrentCategory] = useState('all');
    const [dateState, setDateState] = useState({ dateType: 'daily', startDate: '', endDate: '' });

    const selectCategory = (category) => {
        setCurrentCategory(category);
    };

    const handleDateChange = (newDateState) => {
        const { dateType, startDate, endDate } = newDateState;
        if (dateType !== 'custom') {
            return setDateState({ dateType: dateType, startDate: '', endDate: '' });
        }
        setDateState({ dateType: dateType, startDate: startDate, endDate: endDate });
    };

    return (
        <CommonContainer>
            <S.SalesState>
                <SalesCategory currentCategory={currentCategory} selectCategory={selectCategory} />
                <DateSelector onDateChange={handleDateChange} />
            </S.SalesState>
            <SalesOverview dateState={dateState} currentCategory={currentCategory} />
            {currentCategory !== 'all' && (
                <RouterButton gap={16} href={currentCategory === 'sinor' ? SINOR_ANALYTICS_URL : SILOVE_ANALYTICS_URL}>
                    주요 퍼널별 이탈률 보러가기
                    <ArrowRightOutlined />
                </RouterButton>
            )}
        </CommonContainer>
    );
}
